import React from 'react';
import '../../QueuePage.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate';


const UnassignedTicketQueueHeader = () => (
    <div className="columns">
        <div className='column is-7 is-offset-1'>
            <h3><HrbTranslate text='QueuePage.SortTitles.ReadyToBeAssigned.multiple' /></h3>
            <p className='p1 mt-4'><HrbTranslate text='QueuePage.Labels.UnassignedContent'/></p>
        </div>
        <div className='column is-1' />
        <div className='column is-2'>
        </div>
    </div>
);


export default UnassignedTicketQueueHeader